import { render, staticRenderFns } from "./Cookiebanner.vue?vue&type=template&id=7f22c95f"
import script from "./Cookiebanner.vue?vue&type=script&lang=js"
export * from "./Cookiebanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports